import { injectable, interfaces } from 'inversify';
import { action, makeObservable, observable } from 'mobx';

export interface IUpdateWorkspaceTimeZoneStore {
  readonly selectedTimeZoneOffset: number;
  readonly showModal: boolean;
  readonly workspaceId: string;
  hideForm(): void;
  setSelectedTimeZoneOffset(timeZoneOffset: number): void;
  showForm(workspaceId: string, currentTimeZone: number): void;
}

export namespace IUpdateWorkspaceTimeZoneStore {
  export const $: interfaces.ServiceIdentifier<IUpdateWorkspaceTimeZoneStore> = Symbol('UPDATE_WORKSPACE_TIMEZONE_STORE');
}

@injectable()
export class UpdateWorkspaceTimeZoneStore implements IUpdateWorkspaceTimeZoneStore {
  showModal: boolean = false;

  selectedTimeZoneOffset: number = 0;

  workspaceId: string = '';

  constructor() {
    makeObservable(this, {
      showModal: observable,
      selectedTimeZoneOffset: observable,
      workspaceId: observable,
      hideForm: action,
      showForm: action,
      setSelectedTimeZoneOffset: action,
    });
  }

  hideForm(): void {
    this.showModal = false;
  }

  showForm(workspaceId: string, timeZoneOffset: number): void {
    this.showModal = true;
    this.workspaceId = workspaceId;
    this.selectedTimeZoneOffset = timeZoneOffset;
  }

  setSelectedTimeZoneOffset(timeZoneOffset: number): void {
    this.selectedTimeZoneOffset = timeZoneOffset;
  }
}
